import styled from 'react-emotion';

import BaseTypography from '@material-ui/core/Typography';
import BaseButton from '@material-ui/core/Button';
import BaseListItem from '@ublend-npm/aulaui-next-web/ListItem';
import Avatar from '@ublend-npm/aulaui-next-web/Avatar';

import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

const sideInfoStyle = `
  font-family: ${theme.font.family.workSans};
  padding-left: ${theme.spacing.xxSmall};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.small};
`;
export const Educator = styled('span')`
  ${sideInfoStyle}
  color: ${colors.pink};
`;
export const StudentAdded = styled('span')`
  ${sideInfoStyle}
  color: ${colors.designSystem.success};
`;

export const ListItem = styled(BaseListItem)`
  border-radius: 4px;
  padding: 4px;
  display: flex;
  flex: 1;
  justify-content: space-between;
`;

export const Button = styled(BaseButton)`
  text-transform: none;
  background-color: none;
  color: ${colors.grey11};
  font-size: ${theme.font.size.small};
  :hover {
    background: none;
    opacity: 0.5;
  }
`;

const imageWhiteOverlay = `
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    opacity: 0.6;
`;

export const StyledAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'userAdded',
})`
  flex-shrink: 0;
  &::after {
    ${({ userAdded }) => (userAdded ? imageWhiteOverlay : '')}
  }
`;

export const ParticipantContainer = styled('div')`
  display: flex;
  align-items: center;
`;

export const ParticipantLeftInfo = styled('div')`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-left: ${theme.spacing.small};
`;

export const ParticipantName = styled(BaseTypography, {
  shouldForwardProp: (prop) => prop !== 'userAdded',
})`
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.copy};
  color: ${({ userAdded }) =>
    userAdded
      ? colors.designSystem.blackOpacity60
      : colors.designSystem.blackOpacity87};
`;

export const ParticipantEmail = styled('span')`
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.small};
  font-weight: ${theme.font.weight.regular};
  color: ${colors.designSystem.blackOpacity60};
`;

export const ParticipantNameContainer = styled('div')`
  display: flex;
  flex-wrap: no-wrap;
`;
